module.exports = __webpack_public_path__ + "static/media/redErrorCircle.3b9c936b.svg";